import React from "react";
import { ArrowDown } from "lucide-react";
import { hero } from "../mock";

const mask = (l) => ({
  WebkitMaskImage: `url(/letter-${l}.png)`,
  maskImage: `url(/letter-${l}.png)`,
});

export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden bg-[#0c0c0c]">
      {/* giant CRT letters – exact logo letterforms, template look */}
      <div className="pointer-events-none absolute inset-0 z-10 hidden select-none md:block" aria-hidden="true">
        <div className="hero-letter hero-letter-c" style={mask("c")} />
        <div className="hero-letter hero-letter-r overflow-hidden" style={mask("r")}>
          <img
            src="/r-fill.jpg"
            alt=""
            className="h-full w-full object-cover object-top"
          />
        </div>
        <div className="hero-letter hero-letter-t" style={mask("t")} />
      </div>

      {/* mobile letter composition */}
      <div className="pointer-events-none absolute inset-0 z-10 select-none md:hidden" aria-hidden="true">
        <div className="hero-letter hero-letter-c-m" style={mask("c")} />
        <div className="hero-letter hero-letter-t-m" style={mask("t")} />
      </div>

      {/* content */}
      <div className="relative z-20 mx-auto flex min-h-screen max-w-[1500px] flex-col justify-center px-5 pt-28 md:px-10">
        <div className="max-w-4xl">
          <h1 className="font-display text-[9.2vw] text-white drop-shadow-[0_2px_24px_rgba(0,0,0,0.6)] sm:text-[9vw] md:text-[7.4vw] lg:text-[5.8rem]">
            {hero.lines.map((l, i) => (
              <span key={i} className="block">{l}</span>
            ))}
          </h1>
        </div>
        <p className="mono-label mt-8 max-w-xl text-sm text-[var(--crtr-yellow)]">{hero.sub}</p>
        <p className="mt-4 max-w-xl text-base leading-relaxed text-white/80">{hero.body}</p>
      </div>

      <a
        href="#intro"
        className="absolute bottom-8 left-5 z-20 flex h-12 w-12 items-center justify-center rounded-full border border-white/40 text-white transition-colors hover:border-[var(--crtr-yellow)] hover:text-[var(--crtr-yellow)] md:left-10"
      >
        <ArrowDown className="h-5 w-5" />
      </a>
    </section>
  );
}
